module.exports = __webpack_public_path__ + "img/viewer.ea7fadb9.svg";